<template>
  <el-dialog title="表格列显示设置" :visible.sync="show" width="600px" append-to-body>
    <div style="max-height: 500px; overflow-y: auto;">
      <draggable v-model="localColumns" animation="300" ghost-class="drag-ghost" @change="syncToParent">
        <div
          class="flex items-center justify-between p-2 border rounded mb-2"
          v-for="(item, index) in localColumns"
          :key="item.columnName"
        >
          <i class="el-icon-sort drag mr-2 cursor-move text-gray-400"></i>
          <el-checkbox v-model="item.isShow" class="flex-1" :disabled="index === 0" @change="syncToParent">
            {{ item.columnTitle }}
          </el-checkbox>

          <!-- 上移 / 下移 / 置顶 按钮 -->
          <div class="flex gap-1 ml-2">
            <!-- 置顶：文字 el-button -->
            <el-button size="mini" @click="moveToTop(index)" :disabled="index === 0"> 置顶</el-button>
            <el-button size="mini" icon="el-icon-top" @click="moveUp(index)" :disabled="index === 0" />
            <el-button size="mini" icon="el-icon-bottom" @click="moveDown(index)" :disabled="index === localColumns.length - 1" />
          </div>
        </div>
      </draggable>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="resetDefault">恢复默认</el-button>
      <el-button @click="show = false">取消</el-button>
      <el-button type="primary" @click="saveSetting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'TableColumnSetting',
  components: { draggable },
  props: {
    visible: Boolean,
    columnList: Array,
    storageKey: String,
    defaultColumns: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      localColumns: []
    }
  },
  created () {
    // 🔥 组件一创建就自动初始化！页面不用写任何代码
    this.initTableColumns()
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (val) {
          this.localColumns = JSON.parse(JSON.stringify(this.columnList))
        }
      }
    }
  },
  computed: {
    show: {
      get () { return this.visible },
      set (v) { this.$emit('update:visible', v) }
    }
  },
  methods: {
    // 自动初始化，读取本地缓存
    initTableColumns () {
      const cache = localStorage.getItem(this.storageKey)
      if (cache) {
        try {
          const savedColumns = JSON.parse(cache)
          this.$emit('update:columnList', savedColumns)
        } catch (e) {
          this.$emit('update:columnList', JSON.parse(JSON.stringify(this.defaultColumns)))
        }
      } else {
        this.$emit('update:columnList', JSON.parse(JSON.stringify(this.defaultColumns)))
      }
    },
    syncToParent () {
      this.$emit('update:columnList', this.localColumns)
    },
    saveSetting () {
      if (this.localColumns.length) this.localColumns[0].isShow = true
      localStorage.setItem(this.storageKey, JSON.stringify(this.localColumns))
      this.$emit('update:columnList', this.localColumns)
      this.show = false
    },
    resetDefault () {
      const defaultCols = JSON.parse(JSON.stringify(this.defaultColumns))
      this.localColumns = defaultCols
      localStorage.removeItem(this.storageKey)
      this.$emit('update:columnList', this.localColumns)
    },

    // 上移
    moveUp (index) {
      if (index === 0) return
      const temp = this.localColumns[index]
      this.$set(this.localColumns, index, this.localColumns[index - 1])
      this.$set(this.localColumns, index - 1, temp)
      this.syncToParent()
    },

    // 下移
    moveDown (index) {
      if (index === this.localColumns.length - 1) return
      const temp = this.localColumns[index]
      this.$set(this.localColumns, index, this.localColumns[index + 1])
      this.$set(this.localColumns, index + 1, temp)
      this.syncToParent()
    },

    // ========== 置顶 ==========
    moveToTop (index) {
      if (index === 0) return
      // 取出当前行
      const currItem = this.localColumns[index]
      // 删除当前位置
      this.localColumns.splice(index, 1)
      // 添加到第 0 位
      this.localColumns.unshift(currItem)
      this.syncToParent()
    }
  }
}
</script>

<style scoped>
.drag-ghost { opacity: 0.3; background: #f5f5f5; }
.flex { display: flex; }
.items-center { align-items: center; }
.justify-between { justify-content: space-between; }
.p-2 { padding: 8px; }
.border { border: 1px solid #eee; }
.rounded { border-radius: 4px; }
.mb-2 { margin-bottom: 8px; }
.mr-2 { margin-right: 8px; }
.ml-2 { margin-left: 8px; }
.cursor-move { cursor: move; }
.text-gray-400 { color: #999; }
.flex-1 { flex: 1; }
.gap-1 { gap: 4px; }
</style>



// WEBPACK FOOTER //
// src/components/TableColumnSetting/index.vue